import * as React from 'react'
import { Navigate } from 'react-router-dom'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/employee_onboarding/pages/RootPage'))

const OnboardingTasksPage = React.lazy(
  () => import('modules/employee_onboarding/pages/OnboardingTasksPage')
)
const OnboardingWelcomePage = React.lazy(
  () => import('modules/employee_onboarding/pages/OnboardingWelcomePage')
)

const TaskDetailPage = React.lazy(() => import('modules/employee_onboarding/pages/TaskDetailPage'))

export const onboardingRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employee_onboarding.path,
      element: <RootPage />,
      handle: {
        module: 'employee_onboarding',
      },
      children: [
        {
          index: true,
          element: <Navigate to={navigation.employee_onboarding.welcome.path} replace />,
        },
        {
          path: navigation.employee_onboarding.welcome.path,
          element: <OnboardingWelcomePage />,
        },
        {
          path: navigation.employee_onboarding.onboardingTasks.path,
          handle: {
            meta: () => ({
              title: i18n.t('sidebar.onboarding'),
            }),
          },
          children: [
            {
              index: true,
              element: <OnboardingTasksPage />,
            },
            {
              path: navigation.employee_onboarding.onboardingTasks.taskDetail.path,

              handle: {
                meta: () => ({
                  title: i18n.t('employees.onboarding_welcome.task_details'),
                  description: i18n.t('employees.onboarding_welcome.task_details'),
                  illustration: 'tasks_management',
                }),
              },
              element: <TaskDetailPage />,
            },
          ],
        },
      ],
    },
  ]
}
